<template>
  <CSidebar
      :minimize="minimize"
      :show="show"
      @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
      fixed
  >
    <CSidebarBrand class="d-md-down-none pr-3 pt-1" style="text-decoration: none" to="/mfu/dashboard">
      <CRow>
        <!--        <CCol class="text-right" col="5">-->
        <!--          <img src="../assets/img/logo.png" width="70%"/>-->
        <!--        </CCol>-->
        <CCol class="pt-1 pb-1">
          <label class="font-2xl"><strong>ITEM BANKING</strong></label>
        </CCol>
      </CRow>
      <!--      <img src="../assets/img/logo.png" width="30%"/>-->
      <!--      <label class="mt-4 font-3xl"><strong>MFU</strong></label>-->
      <!--      <CIcon -->
      <!--        class="c-sidebar-brand-full" -->
      <!--        name="logo" -->
      <!--        size="custom-size" -->
      <!--        :height="35" -->
      <!--        viewBox="0 0 556 134"-->
      <!--      />-->
      <!--      <CIcon -->
      <!--        class="c-sidebar-brand-minimized" -->
      <!--        name="logo" -->
      <!--        size="custom-size" -->
      <!--        :height="35" -->
      <!--        viewBox="0 0 110 134"-->
      <!--      />-->
    </CSidebarBrand>

    <CRenderFunction :content-to-render="$options.nav" flat v-if="role==='admin'"/>
    <CRenderFunction :content-to-render="$options.navTeacher" flat v-if="role==='teacher'"/>
    <!--    <CSidebarMinimizer-->
    <!--      class="d-md-down-none"-->
    <!--      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"-->
    <!--    />-->
  </CSidebar>
</template>

<script>
import nav from './_nav'
import navTeacher from './_navTeacher'

export default {
  name: 'TheSidebar',
  props: {
    role: String
  },
  nav,
  navTeacher,
  computed: {
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    }
  }
}
</script>
